// extracted by mini-css-extract-plugin
export default {"clientSec_inner":"clientSec_clientSec_inner__oB1BP","_banner":"clientSec__banner__yMIJf"};